export default {
  bind(el) {
    const thElements = el?.querySelectorAll("th");
    var isDirectionRtl = localStorage.getItem("lang") == "ar" ? true : false;
    if (thElements) {
      thElements.forEach((th) => {
        let startX, startWidth;
 
        const startResize = (e) => {
          startX = e.clientX;
          
          var element = e.currentTarget;
          var parent = element.parentElement;

          const computedWidth = window.getComputedStyle(parent).width;
          if (parent.style.width.includes("%")) {
            const parentWidth = parent.parentElement.offsetWidth;
            startWidth = (parseFloat(parent.style.width) / 100) * parentWidth;
          } else {
            startWidth = parseInt(computedWidth, 10) || 100;
          }
 
          document.addEventListener("mousemove", resizeColumn);
          document.addEventListener("mouseup", stopResize);
        };
 
        const resizeColumn = (e) => {
          var newWidth = startWidth + (e.clientX - startX);
          
          if(isDirectionRtl){
            newWidth = startWidth - (e.clientX - startX);
          }

          if(newWidth < 50){
            newWidth = 50;
          }
          th.style.width = `${newWidth}px`;

        };
 
        const stopResize = () => {
          document.removeEventListener("mousemove", resizeColumn);
          document.removeEventListener("mouseup", stopResize);
        };
 
        const handle = document.createElement("div");
        handle.classList.add("table-resizeable-handle");
        handle.addEventListener("mousedown", startResize);
 
        th.style.position = th.style.position || "relative";
 
        const subHandle = document.createElement("div");
        subHandle.classList.add("table-resizeable-sub-handle");
 
        handle.appendChild(subHandle);
 
        th.appendChild(handle);
      });
    
      var th = thElements[thElements.length - 1];
      if(th)
      th.removeChild(th.children[1]);
      
    }
  },
};